import { SELL_API as axios } from '@services/axiosInstance';

export type NavigationStep = 'SELECT' | 'CHECKOUT' | 'CONFIRMATION';

export interface NavigationResponse {
  currentStep: NavigationStep;
  valid: boolean;
  errors?: { field: string; message: string; code: string }[];
  warnings?: string[];
}

const SESSIONS_PATH = '/sessions';

/** Validates the cart and advances the session to the given step. */
export const navigateNext = async (sessionId: string, step: NavigationStep): Promise<NavigationResponse> => {
  const { data } = await axios.post<NavigationResponse>(`${SESSIONS_PATH}/${sessionId}/navigation/next`, null, {
    params: { step },
  });
  return data;
};

/** Moves the session back to the given step without validation. */
export const navigateBack = async (sessionId: string, step: NavigationStep): Promise<NavigationResponse> => {
  const { data } = await axios.post<NavigationResponse>(`${SESSIONS_PATH}/${sessionId}/navigation/back`, null, {
    params: { step },
  });
  return data;
};
